import createReactComponent from '../createReactComponent';
var WifiOff = createReactComponent('WifiOff', [['line', {
  x1: '2',
  y1: '2',
  x2: '22',
  y2: '22',
  key: '1w4vcy'
}], ['path', {
  d: 'M8.5 16.5a5 5 0 017 0',
  key: '1k36gf'
}], ['path', {
  d: 'M2 8.82a15 15 0 014.17-2.65',
  key: '5m2cef'
}], ['path', {
  d: 'M10.66 5c4.01-.36 8.14.9 11.34 3.76',
  key: 'hxefdu'
}], ['path', {
  d: 'M16.85 11.25a10 10 0 012.22 1.68',
  key: '1aqwxh'
}], ['path', {
  d: 'M5 13a10 10 0 015.24-2.76',
  key: '1yilaw'
}], ['line', {
  x1: '12',
  y1: '20',
  x2: '12.01',
  y2: '20',
  key: 'wbu7xg'
}]]);
export default WifiOff;